export const FILTER_NAME = 'shipment'
